import { render, staticRenderFns } from "./Producttable.vue?vue&type=template&id=d0e50c6e&scoped=true&"
import script from "./Producttable.vue?vue&type=script&lang=js&"
export * from "./Producttable.vue?vue&type=script&lang=js&"
import style0 from "./Producttable.vue?vue&type=style&index=0&id=d0e50c6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e50c6e",
  null
  
)

export default component.exports